module.exports = require("lodash/replace");